import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'LeaseApp.HouseholdApplicationsDrawer.Title',
    defaultMessage: 'Household Applications',
  },
  reviewedItem: {
    id: 'LeaseApp.HouseholdApplicationsDrawer.ReviewedItem',
    defaultMessage: 'Reviewed {itemName}',
  },
});

export default messages;
